import axios from 'axios'
import { Authentication } from '../../store'
import Swal from 'sweetalert2'
import router from "@/router"

import { getLanguage } from "@/utils/locale";
import { messages } from "@/utils/i18n";
const locale: string = messages[getLanguage()]['message'];

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

http.interceptors.request.use((config: any) => {
  if (config.headers === undefined)
    return
  if (Authentication.state.value.token) {
    config.headers.Authorization = `Bearer ${Authentication.state.value.token}`
  }

  return config
})

const errors = {
  'invalid_credentials': locale['validations']['invalid_credentials'],
  'brand_not_found': locale['common']['brand_not_found'],
  'brand_create_success': locale['validations']['brand_create_success'],
  'brand_create_fail': locale['validations']['brand_create_fail'],
  'brand_update_success': locale['validations']['brand_update_success'],
  'brand_update_fail': locale['validations']['brand_update_fail'],
  'brand_delete_success': locale['validations']['brand_delete_success'],
  'brand_delete_fail': locale['validations']['brand_delete_fail'],
  'missing_required_fields': locale['validations']['missing_required_fields'],
  'configuration_not_found': locale['validations']['configuration_not_found'],
  'configuration_create_success': locale['validations']['configuration_create_success'],
  'configuration_create_fail': locale['validations']['configuration_create_fail'],
  'configuration_update_success': locale['validations']['configuration_update_success'],
  'configuration_update_fail': locale['validations']['configuration_update_fail'],
  'not_allowed': locale['common']['not_allowed'],
  'start_date_greater_than_end_date': locale['validations']['start_date_greater_than_end_date'],
  'error_consulting_database': locale['validations']['error_consulting_database'],
  'goal_not_found': locale['common']['goal_not_found'],
  'goal_required_field_missing': locale['messages']['goal_required_field_missing'],
  'resale_not_found': locale['common']['partner_not_found'],
  'warehouse_not_found': locale['common']['warehouse_not_found'],
  'trigger_item_not_found': locale['validations']['trigger_item_not_found'],
  'triger_item_value_not_defined': locale['validations']['triger_item_value_not_defined'],
  'clearance_sale_reward_not_defined': locale['validations']['clearance_sale_reward_not_defined'],
  'goal_create_fail': locale['common']['goal_create_fail'],
  'goal_create_success': locale['common']['goal_create_success'],
  'reason_required': locale['validations']['reason_required'],
  'goal_update_success': locale['common']['goal_update_success'],
  'goal_update_fail': locale['common']['goal_update_fail'],
  'users_id should not be null or undefined': locale['validations']['users_ids_null'],
  'roles_id should not be null or undefined': locale['validations']['roles_ids_null'],
  'seasons_id should not be null or undefined': locale['validations']['seasons_ids_null'],
  'performant should not be null or undefined': locale['validations']['performants_null'],
  'goal_lines should not be null or undefined': locale['validations']['goal_liness_null'],
  'goal_user_not_found': locale['validations']['goal_user_not_found'],
  'goal_role_not_found': locale['validations']['goal_role_not_found'],
  'goal_seller_not_found': locale['validations']['goal_seller_not_found'],
  'goal_season_not_found': locale['validations']['season_not_found'],
  'goal_already_exists': locale['messages']['goal_already_exists'],
  'invoice_not_found': locale['validations']['invoice_not_found'],
  'item_not_found': locale['validations']['item_not_found'],
  'performant_not_found': locale['validations']['performant_not_found'],
  'preview_not_found': locale['validations']['preview_not_found'],
  'provision_not_found': locale['validations']['provision_not_found'],
  'reception_not_found': locale['validations']['reception_not_found'],
  'resale_create_success': locale['validations']['resale_create_success'],
  'resale_create_fail': locale['validations']['resale_create_fail'],
  'resale_update_success': locale['validations']['resale_update_success'],
  'resale_update_fail': locale['validations']['resale_update_fail'],
  'resale_delete_fail': locale['validations']['resale_delete_fail'],
  'resale_delete_success': locale['validations']['resale_delete_success'],
  'role_not_found': locale['validations']['role_not_found'],
  'role_create_success': locale['validations']['role_create_success'],
  'role_create_fail': locale['validations']['role_create_fail'],
  'role_update_success': locale['validations']['role_update_success'],
  'role_update_fail': locale['validations']['role_update_fail'],
  'role_delete_fail': locale['validations']['role_delete_fail'],
  'role_delete_success': locale['validations']['role_delete_success'],
  'season_not_found': locale['validations']['season_not_found'],
  'season_hundred_error': locale['validations']['season_hundred_error'],
  'season_create_success': locale['validations']['season_create_success'],
  'season_create_fail': locale['validations']['season_create_fail'],
  'season_delete_fail': locale['validations']['season_delete_fail'],
  'season_delete_success': locale['validations']['season_delete_success'],
  'trigger_not_found': locale['validations']['trigger_not_found'],
  'trigger_items_not_set': locale['validations']['trigger_items_not_set'],
  'trigger_item_value_error': locale['validations']['trigger_item_value_error'],
  'trigger_item_hundred_error': locale['validations']['trigger_item_hundred_error'],
  'trigger_item_create_fail': locale['validations']['trigger_item_create_fail'],
  'trigger_create_success': locale['validations']['trigger_create_success'],
  'trigger_create_fail': locale['validations']['trigger_create_fail'],
  'trigger_item_delete_fail': locale['validations']['trigger_item_delete_fail'],
  'trigger_delete_fail': locale['validations']['trigger_delete_fail'],
  'trigger_delete_success': locale['validations']['trigger_delete_success'],
  'user_not_found': locale['validations']['user_not_found'],
  'user_create_success': locale['validations']['user_create_success'],
  'user_create_fail': locale['validations']['user_create_fail'],
  'user_update_success': locale['validations']['user_update_success'],
  'user_update_fail': locale['validations']['user_update_fail'],
  'user_delete_success': locale['validations']['user_delete_success'],
  'user_delete_fail': locale['validations']['user_delete_fail'],
  'preference_not_set': locale['validations']['preference_not_set'],
  'user_preference_success': locale['validations']['user_preference_success'],
  'user_preference_fail': locale['validations']['user_preference_fail'],
  'warehouse_create_success': locale['validations']['warehouse_create_success'],
  'warehouse_create_fail': locale['validations']['warehouse_create_fail'],
  'warehouse_update_success': locale['validations']['warehouse_update_success'],
  'warehouse_update_fail': locale['validations']['warehouse_update_fail'],
  'warehouse_delete_success': locale['validations']['warehouse_delete_success'],
  'warehouse_delete_fail': locale['validations']['warehouse_delete_fail'],
  'unauthorized': locale['validations']['unauthorized'],
  'Internal Server Error': locale['validations']['InternalServer_Error'],
  'only_image_allowed': locale['validations']['only_image_allowed'],
  'resale_already_exists': locale['validations']['resale_already_exists'],
  'sap_users_id': locale['validations']['sap_users_id'],
  'name': locale['validations']['sap_card_name'],
  'sap_card_code': locale['validations']['sap_card_code'],
  'sap_card_name': locale['validations']['sap_card_name'],
  'sap_aidc_brand_code': locale['validations']['sap_code'],
  'sap_code': locale['validations']['sap_code'],
  'company': locale['validations']['company'],
  'start_date': locale['validations']['start_date'],
  'end_date': locale['validations']['end_date'],
  'jan': locale['validations']['jan'],
  'feb': locale['validations']['feb'],
  'mar': locale['validations']['mar'],
  'apr': locale['validations']['apr'],
  'may': locale['validations']['may'],
  'jun': locale['validations']['jun'],
  'jul': locale['validations']['jul'],
  'aug': locale['validations']['aug'],
  'sep': locale['validations']['sep'],
  'oct': locale['validations']['oct'],
  'nov': locale['validations']['nov'],
  'dec': locale['validations']['dec'],
  'brands_required': locale['validations']['brands_required'],
  'brand_already_registered': locale['validations']['brand_already_registered'],
  'items_required': locale['validations']['items_required'],
  'invoice_or_item_not_found': locale['validations']['invoice_or_item_not_found'],
  'item_update_fail': locale['validations']['item_update_fail'],
  'item_update_success': locale['validations']['item_update_success'],
}

http.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    let message = error?.response?.data?.message;
    if (Array.isArray(error?.response?.data)) {
      message = error?.response?.data[0].field;
    }
    if (error.response.status === 401) {

      Swal.fire({
        icon: "warning",
        title: locale['common']['atention'],
        text: locale['common']['session_expired_message']
      }).then(() => {
        Authentication.actions.logout();
        router.push("/");
      });
    } else if ([400, 404, 406].includes(error.response.status)) {
      Swal.fire({
        icon: "warning",
        title: locale['common']['atention'],
        text: errors[message] ?? message
      });
    } else if (error.response.status === 500) {
      Swal.fire({
        icon: "error",
        title: locale['common']['atention'],
        text: errors[message] ?? message ?? locale['common']['unexpected_error'],
      });
    }

    return Promise.reject(error)
  },
)

export { http }